import React, { Component } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';

import * as Helpers from '../helpers';

const tableStatuses = {
  loan: ['requested', 'disbursed', 'disbursing', 'serviced', 'cancelled', 'issued', 'repaid'], // toLowercase()
  repayment: [],
  withdrawal: ['completed', 'rejected'],
};

const todayDate = moment();

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRange: {
        endDate: '',
        startDate: '',
      },
      selectedDateFilter: '',
      showDatePicker: false,
    };
  }

  componentDidMount() {
    // Initialize with selected date range if provided
    const { selectedDateRange } = this.props;
    if (selectedDateRange && selectedDateRange.from && selectedDateRange.to) {
      this.setState({
        dateRange: {
          startDate: moment(selectedDateRange.from),
          endDate: moment(selectedDateRange.to)
        },
        selectedDateFilter: 'custom'
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Update state when selectedDateRange changes
    const { selectedDateRange } = this.props;
    if (selectedDateRange !== prevProps.selectedDateRange) {
      if (selectedDateRange && selectedDateRange.from && selectedDateRange.to) {
        this.setState({
          dateRange: {
            startDate: moment(selectedDateRange.from),
            endDate: moment(selectedDateRange.to)
          },
          selectedDateFilter: 'custom'
        });
      } else {
        // Reset if no date range
        this.setState({
          dateRange: {
            endDate: '',
            startDate: '',
          },
          selectedDateFilter: ''
        });
      }
    }
  }

  handleDateFilterClick = filter => {
    this.setState(() => {
      let startDate;
      let endDate;
      switch (filter) {
      case 'Last Week':
        startDate = moment().subtract(1, 'weeks').startOf('isoWeek');
        endDate = moment().subtract(1, 'weeks').endOf('isoWeek');
        break;
      case 'Last Month':
        startDate = moment().subtract(1, 'months').startOf('month');
        endDate = moment().subtract(1, 'months').endOf('month');
        break;
      case 'Last Year':
        startDate = moment().subtract(1, 'years').startOf('year');
        endDate = moment().subtract(1, 'years').endOf('year');
        break;
      default:
        startDate = todayDate;
        endDate = todayDate;
      }

      return {
        dateRange: { endDate, startDate },
        selectedDateFilter: filter,
        showDatePicker: false,
      };
    });
  };

  toggleDatePicker = () => {
    this.setState(prevState => ({
      showDatePicker: !prevState.showDatePicker,
    }));
  };

  handleDateChange = ranges => {
    const { selection } = ranges;
    if (selection.startDate && selection.endDate) {
      this.setState({
        dateRange: {
          endDate: moment(selection.endDate).endOf('day'),
          startDate: moment(selection.startDate).startOf('day'),
        },
      });
    }
  };

  handleApplyFilters = () => {
    const { handleFilterSelection, selectedStatuses } = this.props;
    const { dateRange } = this.state;
    handleFilterSelection(selectedStatuses, dateRange);
  };

  handleClearFilters = () => {
    const { resetFilters } = this.props;
    this.setState({
      dateRange: {
        endDate: '',
        startDate: '',
      },
      selectedDateFilter: '',
      // selectedStatuses: [],
    });
    resetFilters();
  };

  render() {
    const {
      selectedDateFilter, showDatePicker, dateRange,
    } = this.state;
    const { table, selectedStatuses, handleStatusClick } = this.props;

    return (
      <div className="filters-container">
        <h3>
          {Helpers.capitalizeFirstLetter3(table.toLowerCase() === 'loan' ? 'Credit' : table)} Filters
        </h3>
        {tableStatuses[table].length > 0 && (
          <div className="filter-section">
            <h4 className="byStatus">
              By Status:
              {' '}
              {selectedStatuses.join(', ')}
            </h4>
            <div><hr id="horizontal-lineB" /></div>
            <div className="status-options">
              {tableStatuses[table].map(status => (
                <button
                  key={status}
                  className={`status-button ${selectedStatuses.includes(status) ? 'selected' : ''}`}
                  onClick={() => handleStatusClick(status)}
                >
                  {Helpers.capitalizeFirstLetter3(status)}
                </button>
              ))}
            </div>
          </div>
        )}
        <div className="filter-section">
          <h4 className="byDate">
            By Date:
            {' '}
            {
            selectedDateFilter && dateRange.startDate
              ? `${dateRange.startDate.format('DD MMMM YYYY')} - ${dateRange.endDate.format('DD MMMM YYYY')}`
              : ''
            }
          </h4>
          <div><hr id="horizontal-lineB" /></div>
          <div className="date-options">
            {['Last Week', 'Last Month', 'Last Year'].map(filter => (
              <label key={filter}>
                <input
                  type="checkbox"
                  checked={selectedDateFilter === filter}
                  onChange={() => this.handleDateFilterClick(filter)}
                />
                {filter}
              </label>
            ))}
          </div>
          <label className="date-range-label">
            <input
              type="checkbox"
              checked={selectedDateFilter === 'Pick a date range'}
              onChange={() => {
                this.handleDateFilterClick('Pick a date range');
                this.toggleDatePicker();
              }}
            />
            Pick a date range
          </label>
          {showDatePicker && ( // there should be a single date component for the dashboard
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <DateRange
                ranges={[
                  {
                    endDate: dateRange.endDate ? dateRange.endDate.toDate() : new Date(),
                    key: 'selection',
                    startDate: dateRange.startDate ? dateRange.startDate.toDate() : new Date(),
                  },
                ]}
                onChange={this.handleDateChange}
                moveRangeOnFirstSelection={false}
              />
            </div>
          )}
        </div>
        <div className="filter-buttons">
          <button className="clear-button" onClick={this.handleClearFilters}>
            Clear all Filters
          </button>
          <button className="apply-button" onClick={this.handleApplyFilters}>
            Apply
          </button>
        </div>
      </div>
    );
  }
}

export default Filters;
